import { Routes, Route, Navigate } from 'react-router-dom';
import { SignedIn as ClerkSignedIn, SignedOut as ClerkSignedOut, RedirectToSignIn as ClerkRedirectToSignIn } from '@clerk/clerk-react';
import { SignedIn as DevSignedIn, SignedOut as DevSignedOut, RedirectToSignIn as DevRedirectToSignIn } from './contexts/DevAuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import BacklinkDetail from './pages/BacklinkDetail';
import Alerts from './pages/Alerts';
import Import from './pages/Import';
import Settings from './pages/Settings';
import Integrations from './pages/Integrations';
import Formulas from './pages/Formulas';
import SearchConsole from './pages/SearchConsole';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import DevCheckout from './pages/DevCheckout';
import Providers from './pages/Providers';
import ProviderScorecard from './pages/ProviderScorecard';
import Rankings from './pages/Rankings';
import NotFound from './pages/NotFound';

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const hasValidClerkKey = clerkPubKey && clerkPubKey.startsWith('pk_') && clerkPubKey.length > 30;

// Use appropriate auth components based on whether we have valid Clerk keys
const SignedIn = hasValidClerkKey ? ClerkSignedIn : DevSignedIn;
const SignedOut = hasValidClerkKey ? ClerkSignedOut : DevSignedOut;
const RedirectToSignIn = hasValidClerkKey ? ClerkRedirectToSignIn : DevRedirectToSignIn;

function ProtectedRoute({ children }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dev-checkout" element={<DevCheckout />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Navigate to="/" replace />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
        <Route path="backlinks/:id" element={<BacklinkDetail />} />
        <Route path="providers" element={<Providers />} />
        <Route path="providers/:id" element={<ProviderScorecard />} />
        <Route path="alerts" element={<Alerts />} />
        <Route path="rankings" element={<Rankings />} />
        <Route path="search-console" element={<SearchConsole />} />
        <Route path="import" element={<Import />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="formulas" element={<Formulas />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
